import action from './action'

export default {
    getStores(data) {
        return action.request('get_welcom_stores',data)
    },
    setPreferredStore(data) {
        return action.request('set_welcom_preferred_store',data)
    }
}
